var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticallyDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6C9.60218 6 9.22064 5.84196 8.93934 5.56066C8.65803 5.27936 8.5 4.89782 8.5 4.5C8.5 4.10218 8.65804 3.72064 8.93934 3.43934C9.22064 3.15804 9.60218 3 10 3C10.3978 3 10.7794 3.15804 11.0607 3.43934C11.342 3.72064 11.5 4.10218 11.5 4.5C11.5 4.89782 11.342 5.27936 11.0607 5.56066C10.7794 5.84196 10.3978 6 10 6ZM10 12C9.60217 12 9.22064 11.842 8.93934 11.5607C8.65803 11.2794 8.5 10.8978 8.5 10.5C8.5 10.1022 8.65803 9.72064 8.93934 9.43934C9.22064 9.15804 9.60217 9 10 9C10.3978 9 10.7794 9.15804 11.0607 9.43934C11.342 9.72064 11.5 10.1022 11.5 10.5C11.5 10.8978 11.342 11.2794 11.0607 11.5607C10.7794 11.842 10.3978 12 10 12ZM8.5 16.5C8.5 16.8978 8.65803 17.2794 8.93934 17.5607C9.22064 17.842 9.60217 18 10 18C10.3978 18 10.7794 17.842 11.0607 17.5607C11.342 17.2794 11.5 16.8978 11.5 16.5C11.5 16.1022 11.342 15.7206 11.0607 15.4393C10.7794 15.158 10.3978 15 10 15C9.60217 15 9.22064 15.158 8.93934 15.4393C8.65803 15.7206 8.5 16.1022 8.5 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticallyDots);
export default __webpack_public_path__ + "static/media/vertically-dots.44e1e7dbfc52ca1a396a22f5347bd207.svg";
export { ForwardRef as ReactComponent };